export function initFormValidator() {
  const mainForm = document.querySelector('#contact-form');
  const modalForm = document.querySelector('#modal-demo-form');

  const handleFormSubmit = (e, form) => {
    e.preventDefault();
    const btn = form.querySelector('button[type="submit"]');
    const originalText = btn ? btn.textContent : '';

    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Enviando solicitud...';
    }

    setTimeout(() => {
      if (btn) {
        btn.textContent = '✓ ¡Demostración Agendada!';
        btn.style.background = 'linear-gradient(135deg, #10b981 0%, #059669 100%)';
      }

      setTimeout(() => {
        form.reset();
        if (btn) {
          btn.disabled = false;
          btn.textContent = originalText;
          btn.style.background = '';
        }

        const modal = document.querySelector('#demo-modal');
        if (modal && modal.classList.contains('active')) {
          modal.classList.remove('active');
          document.body.style.overflow = '';
        }
      }, 2500);
    }, 1200);
  };

  mainForm?.addEventListener('submit', (e) => handleFormSubmit(e, mainForm));
  modalForm?.addEventListener('submit', (e) => handleFormSubmit(e, modalForm));
}
